module.exports = __webpack_public_path__ + "static/6-cde3c1c5f264c5c2b8237120276d8070.jpg";